import { useContext } from "react"
import { AuthContext } from "../providers/contexts/AuthContext";

export const useAuth = () => {
    return useContext(AuthContext);
}